import { render } from "./TheTrackerList.vue?vue&type=template&id=3f1978d7"
import script from "./TheTrackerList.vue?vue&type=script&lang=js"
export * from "./TheTrackerList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__